module.exports = __webpack_public_path__ + "img/图层 1495.9846cc7b.png";